<template>
    <div class="field col-12 md:col-4">
        <base-dropdown v-model="incident.category" label="Category" :options="categories" :errorMessage="formErrors.category" :disabled="editMode" />
    </div>
    <template v-if="incidentDisabled">
        <div class="field col-12 md:col-4">
            <custom-tree-select v-model="incident.property_type_id" label="Property Type" :optionsTree="propertyTypesTree" :error-message="formErrors.propertyTypeId" :disabled="editMode" />
        </div>
    </template>
    <template v-else-if="incident.category !== IncidentCategory.NON_OPERATIONAL">
        <template v-if="editMode">
            <div class="field col-12 md:col-4">
                <base-number-input v-model="incident.incident_number" label="Incident Number" :disabled="editMode" />
            </div>
        </template>
        <template v-else>
            <div class="field col-12 md:col-4">
                <IncidentSelection v-model="incident.incident_number" :errorMessage="formErrors.incidentNumber" @disable-date-change="disabledDateSwitch" />
            </div>
        </template>
    </template>
    <div class="field col-12 md:col-4">
        <base-calendar-input v-model="incident.incident_date" label="Incident Date" :maxDate="maxDateValue" :errorMessage="formErrors.incidentDate" :disabled="disableIncidentDate || editMode" />
    </div>
    <div v-if="incidentDisabled" class="field col-12">
        <label for="label">Summary</label>
        <Textarea id="textareaOptions" rows="5" v-model="incident.summary" />
    </div>
</template>

<script setup>
import IncidentSelection from '../components/IncidentSelection.vue';

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { incidentStore, propertyTypeStore, formErrorStore, debriefStore } from '../../../../../store/global-stores';
import { getAllIncidentCategories } from '../constants/index';
import { IncidentCategory } from '../enum';

const { incident } = storeToRefs(incidentStore);
const { propertyTypesTree } = storeToRefs(propertyTypeStore);
const { formErrors } = storeToRefs(formErrorStore);
const { editId } = storeToRefs(debriefStore);

const disableIncidentDate = ref(false);
const maxDateValue = ref(new Date());

onMounted(() => {
    propertyTypeStore.fetchAllPropertyTypes();
});

onUnmounted(() => {
    incidentStore.initIncidentForm();
});

// computed properties
const categories = computed(() => {
    return getAllIncidentCategories();
});

const incidentDisabled = computed(() => {
    return (incident.value.category && incident.value.category !== IncidentCategory.INCIDENT) ?? false;
});

const editMode = computed(() => {
    return editId.value ? true : false;
});

// actions
// As per the changes in the Incidents selection, date switch is disabled or enabled accordingly
const disabledDateSwitch = (flag) => {
    disableIncidentDate.value = flag;
};
</script>
